import { createStore } from "vuex";

export default createStore({
  state: {
    tariff: 0,
  },
  getters: {},
  mutations: {
    updateData(state, result){
      this.state.tariff = result;
    }
  },
  actions: {
    async getDataFromDb({ commit }) {
      try {
        let response = await fetch(
          `https://proton.spb.su/api/calc/to/get_data_to.php`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              // 'Content-Type': 'application/json',
              // 'Content-Type': 'application/json;charset=utf-8'
            },
          }
        );
        let result = await response.json();
        commit("updateData", +result[0].tariff);
      } catch (error) {
        console.log("errrrrr");
      }
    },
  },
  modules: {},
});
